import { useState } from "react";
import { FolderOpen } from "lucide-react";
import { FileTree } from "./FileTree";
import { DocumentViewer } from "./DocumentViewer";
import type { Project } from "@/stores/worldStore";

export function DocumentsTab({ project }: { project: Project }) {
  const [selectedPath, setSelectedPath] = useState<string | null>(null);
  const base = project.localPath;
  const root = base && project.subdirectory ? `${base}/${project.subdirectory}` : base;

  if (!root) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-2 text-colony-text-tertiary">
        <FolderOpen className="h-8 w-8" strokeWidth={1} />
        <span className="text-sm">This project has no local folder linked</span>
      </div>
    );
  }
  return (
    <div className="flex h-full min-h-0">
      <div className="w-64 shrink-0 border-r border-colony-border">
        <FileTree root={root} onSelect={setSelectedPath} selectedPath={selectedPath} />
      </div>
      <div className="min-w-0 flex-1">
        <DocumentViewer path={selectedPath} />
      </div>
    </div>
  );
}
